import { render } from "./CourseQuestions.vue?vue&type=template&id=520d8222&scoped=true"
import script from "./CourseQuestions.vue?vue&type=script&lang=js"
export * from "./CourseQuestions.vue?vue&type=script&lang=js"

import "./CourseQuestions.vue?vue&type=style&index=0&id=520d8222&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520d8222"]])

export default __exports__